<app-navbar />
<div class="container-fluid">
    <div class="panel modern-card">
        <div class="panel-header modern-header">
            <h2>
                <i class="fas fa-users me-2"></i>
                Consulta de Clientes
            </h2>
        </div>
        <div class="panel-body">
            <!-- Filtros avançados -->
            <div class="filtro-form modern-form">
                <div class="filter-container">
                    <button class="btn btn-info" type="button" (click)="showFiltros = !showFiltros">
                        <i class="fas fa-filter me-1"></i> Filtrar
                    </button>
                </div>
                <div [ngClass]="{'filtros-endereco': true, 'ativo': showFiltros}">
                    <div class="form-group">
                        <label for="nome">Nome</label>
                        <input id="nome" type="text" [(ngModel)]="searchFields.nome" class="form-control filter-input"
                            placeholder="Nome">
                    </div>
                    <div class="form-group">
                        <label for="cpf">CPF</label>
                        <input id="cpf" type="text" [(ngModel)]="searchFields.cpf" class="form-control filter-input"
                            placeholder="CPF">
                    </div>
                    <div class="form-group">
                        <label for="numeroOS">Vistoria</label>
                        <input id="numeroOS" type="text" [(ngModel)]="searchFields.numeroOS"
                            class="form-control filter-input" placeholder="Número Vistoria">
                    </div>
                    <div class="form-group">
                        <label for="logradouro">Logradouro</label>
                        <input id="logradouro" type="text" [(ngModel)]="searchFields.logradouro"
                            class="form-control filter-input" placeholder="Logradouro (Rua)">
                    </div>
                    <div class="form-group">
                        <label for="numero">Número</label>
                        <input id="numero" type="text" [(ngModel)]="searchFields.numero"
                            class="form-control filter-input" placeholder="Número">
                    </div>
                    <div class="form-group">
                        <label for="estado">Estado</label>
                        <input id="estado" type="text" [(ngModel)]="searchFields.estado"
                            class="form-control filter-input" placeholder="Estado">
                    </div>
                    <div class="form-group">
                        <label for="cidade">Cidade</label>
                        <input id="cidade" type="text" [(ngModel)]="searchFields.cidade"
                            class="form-control filter-input" placeholder="Cidade">
                    </div>
                    <div class="form-group">
                        <label for="bairro">Bairro</label>
                        <input id="bairro" type="text" [(ngModel)]="searchFields.bairro"
                            class="form-control filter-input" placeholder="Bairro">
                    </div>
                    <div class="form-group">
                        <label for="cep">CEP</label>
                        <input id="cep" type="text" [(ngModel)]="searchFields.cep" class="form-control filter-input"
                            placeholder="CEP">
                    </div>
                    <div class="form-buttons modern-buttons" style="width: 100%; margin-top: 10px;">
                        <button class="btn btn-primary me-2" (click)="applyFilters()" title="Buscar">
                            <i class="fas fa-search me-1"></i> Buscar
                        </button>
                        <button class="btn btn-secondary me-2" (click)="clearFilters()" title="Limpar filtros">
                            <i class="fas fa-eraser me-1"></i> Limpar
                        </button>
                        <!-- moved page-size selector to pagination area -->
                    </div>

                </div>
                <!-- Select de colaboradores e botão Atribuir -->
                <div class="atribuir-colaborador modern-card">
                    <label class="atribuir-label">Atribuir selecionados para:</label>
                    <select class="form-select atribuir-select" [(ngModel)]="colaboradorSelecionado">
                        <option value="">Selecione um colaborador</option>
                        <option *ngFor="let colab of colaboradores" [value]="colab.id">{{ colab.nome }}</option>
                    </select>
                    <button class="btn btn-success"
                            (click)="atribuirSelecionados()"
                            [disabled]="!colaboradorSelecionado || !temSelecionado() || isDistribuindo">
                        <ng-container *ngIf="!isDistribuindo; else atribuindoTpl">
                            <i class="fas fa-user-plus me-1"></i> Atribuir
                        </ng-container>
                        <ng-template #atribuindoTpl>
                            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                            Atribuindo...
                        </ng-template>
                    </button>
                    <span class="atribuir-hint">Selecione clientes na tabela para atribuir</span>
                </div>
                <!-- Mensagem de sucesso -->
                <div *ngIf="mensagemSucesso" class="alert alert-success modern-alert mensagem-sucesso">
                    <i class="fas fa-check-circle me-1"></i>
                    {{ mensagemSucesso }}
                    <button type="button" class="btn-close float-end fechar-alerta" aria-label="Fechar"
                        (click)="mensagemSucesso = ''"></button>
                </div>
            </div>

            <!-- Loading spinner -->
            <div *ngIf="loading" class="carregando-container modern-loader">
                <div class="modern-spinner"></div>
                <p>Carregando clientes...</p>
            </div>

            <!-- Error message -->
            <div *ngIf="error" class="erro-container modern-error">
                <i class="fas fa-exclamation-triangle"></i>
                <p>{{ error }}</p>
                <button (click)="loadAllClientes()" class="btn btn-outline-primary">
                    <i class="fas fa-sync-alt"></i> Tentar novamente
                </button>
            </div>

            <!-- No results message -->
            <div *ngIf="!loading && !error && (!clientes || clientes.length === 0)" class="sem-resultados modern-empty">
                <i class="fas fa-info-circle"></i>
                <p>Nenhum cliente encontrado com os filtros aplicados.</p>
            </div>

            <div *ngIf="!loading && !error && clientes && clientes.length > 0"
                class="table-container modern-table-container">
                <table class="table table-striped modern-table">
                    <thead>
                        <tr>
                            <th style="width: 40px; text-align: center;">
                                <input type="checkbox" [checked]="allSelected" (change)="toggleSelectAll($event)">
                            </th>
                            <th style="width: 100px;">
                                <span class="th-icon-label" style="cursor: pointer;" (click)="toggleSort(5)">
                                    <span>Vistoria</span>
                                    <i [ngClass]="getSortIcon(5) + ' ms-2'"></i>
                                </span>
                            </th>
                            <th class="text-center">
                                <span class="th-icon-label" style="cursor: pointer;" (click)="toggleSort(0)">
                                    <span>Nome</span>
                                    <i [ngClass]="getSortIcon(0) + ' ms-2'"></i>
                                </span>
                            </th>
                            <th>
                                <span class="th-icon-label">
                                    <span>CPF/CNPJ</span>
                                </span>
                            </th>
                            <th>
                                <span class="th-icon-label" style="cursor: pointer;" (click)="toggleSort(1)">
                                    <span>Logradouro</span>
                                    <i [ngClass]="getSortIcon(1) + ' ms-2'"></i>
                                </span>
                            </th>
                            <th>
                                <span class="th-icon-label" style="cursor: pointer;" (click)="toggleSort(4)">
                                    <span>NUMERO</span>
                                    <i [ngClass]="getSortIcon(4) + ' ms-2'"></i>
                                </span>
                            </th>
                            <th>
                                <span class="th-icon-label" style="cursor: pointer;" (click)="toggleSort(2)">
                                    <span>Bairro</span>
                                    <i [ngClass]="getSortIcon(2) + ' ms-2'"></i>
                                </span>
                            </th>
                            <th>
                                <span class="th-icon-label" style="cursor: pointer;" (click)="toggleSort(3)">
                                    <span>Cidade</span>
                                    <i [ngClass]="getSortIcon(3) + ' ms-2'"></i>
                                </span>
                            </th>
                            <th>
                                <span class="th-icon-label">
                                    <span>Status</span>
                                </span>
                            </th>
                            <!-- Coluna Ações removida -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let cliente of clientes; let i = index" 
                            (click)="toggleRowSelection(cliente, $event)" 
                            [ngClass]="{'row-selected': cliente.selected}"
                            style="cursor: pointer;">
                            <td style="text-align: center;">
                                <input type="checkbox" [(ngModel)]="cliente.selected">
                            </td>
                            <td style="width: 100px;"><span class="dados-text ">{{ cliente.numeroOS || 'Sem Dados' }}</span>
                            </td>
                            <td><strong class="dados-text">{{ cliente.nomeConsumidor || '-' }}</strong></td>
                            <td><span class="cpf-text">{{ formatDocumento(cliente.cpf ?? cliente.cnpj ?? cliente.documento ?? cliente.cpfCnpj) || '-' }}</span></td>
                            <td>
                                {{ cliente.endereco?.logradouro || '-' }}
                            </td>
                            <td>
                                {{ cliente.endereco?.numero || '-' }}
                            </td>
                            <td>
                                {{ cliente.endereco?.bairro || '-' }}
                            </td>
                            <td>
                                {{ cliente.endereco?.localidade || '-' }}
                            </td>

                            <td>
                                <span [ngClass]="{
                                    'badge badge-pendente': cliente.statusOS === 'Pendente',
                                    'badge badge-retornar': cliente.statusOS === 'Retornar',
                                    'badge bg-secondary': !cliente.statusOS
                                }">
                                    {{ cliente.statusOS || 'Não iniciado' }}
                                </span>
                            </td>
                            <!-- Célula de ação removida -->
                        </tr>
                    </tbody>
                </table>

                <!-- Paginação -->
                <div class="pagination-container">
                    <div class="pagination-info">
                        Mostrando {{ getStartItem() }} - {{ getEndItem() }} de {{ totalItens }} registros | Página {{paginaAtual}} de {{totalPaginas}}
                    </div>
                    <div style="display:flex; gap:12px; align-items:center;">
                        <label style="margin:0; font-weight:600;">Mostrar</label>
                        <select class="form-select" [(ngModel)]="tamanhoPagina" (change)="mudarTamanhoPagina(tamanhoPagina)" style="width:100px;">
                            <option [value]="5">5</option>
                            <option [value]="10">10</option>
                            <option [value]="25">25</option>
                            <option [value]="50">50</option>
                            <option [value]="100">100</option>
                            <option [value]="150">150</option>
                        </select>
                        <label style="margin:0; font-weight:600;">por página</label>
                    </div>
                    <nav aria-label="Navegação de páginas">
                        <ul class="pagination">
                            <li class="page-item" [class.disabled]="paginaAtual === 1">
                                <a class="page-link" href="#" (click)="$event.preventDefault(); mudarPagina(1)" aria-label="Primeira">
                                    <span aria-hidden="true">&laquo;</span>
                                </a>
                            </li>
                            <li class="page-item" [class.disabled]="paginaAtual === 1">
                                <a class="page-link" href="#" (click)="$event.preventDefault(); mudarPagina(paginaAtual - 1)" aria-label="Anterior">
                                    <span aria-hidden="true">&lsaquo;</span>
                                </a>
                            </li>

                            <ng-container *ngFor="let pagina of getVisiblePageNumbers()">
                                <li *ngIf="pagina === '...'" class="page-item disabled page-ellipsis"><span class="page-link">&hellip;</span></li>
                                <li *ngIf="pagina !== '...'" class="page-item" [class.active]="pagina === paginaAtual">
                                    <a class="page-link" href="#" (click)="$event.preventDefault(); mudarPagina(pagina)">{{pagina}}</a>
                                </li>
                            </ng-container>

                            <li class="page-item" [class.disabled]="paginaAtual === totalPaginas || totalPaginas === 0">
                                <a class="page-link" href="#" (click)="$event.preventDefault(); mudarPagina(paginaAtual + 1)" aria-label="Próxima">
                                    <span aria-hidden="true">&rsaquo;</span>
                                </a>
                            </li>
                            <li class="page-item" [class.disabled]="paginaAtual === totalPaginas || totalPaginas === 0">
                                <a class="page-link" href="#" (click)="$event.preventDefault(); mudarPagina(totalPaginas)" aria-label="Última">
                                    <span aria-hidden="true">&raquo;</span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</div>